const OPTIONS = [
  { value: "single", label: "Single" },
  { value: "married_joint", label: "Married Filing Jointly" },
  { value: "married_separate", label: "Married Separate" },
  { value: "head_of_household", label: "Head of Household" },
];

export const FilingStatusSelector = ({ value, onChange, testid }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-0 border border-foreground" data-testid={testid || "filing-status-selector"}>
      {OPTIONS.map((o, i) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            onClick={() => onChange(o.value)}
            data-testid={`filing-status-${o.value}`}
            className={`p-3 font-mono text-xs uppercase tracking-wider transition-colors border-foreground ${
              i < OPTIONS.length - 1 ? "border-r" : ""
            } ${i < 2 ? "border-b md:border-b-0" : ""} ${
              active
                ? "bg-foreground text-background"
                : "bg-background text-foreground hover:bg-muted"
            }`}
            type="button"
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};
